import axios from 'axios';
import { csvListService } from '../../services'
import { createintegrationService } from '../../services/createintegration.service';
import { csvIntegrationConstant, reportTpes } from '../constants';
import { apiUrl } from '../../constant';

export const getCsvDataAction = (createdBy) => {
    return () => {
        return csvListService.getCsvData(createdBy);
    }
}
export const getCsvAllIntegrationAction = (data) => {
    return () => {
        return csvListService.getCsvAllIntegration(data);
    }
}
export const UpdateSkipDuplicateAddressCheckFlag = (event, autGenerateId) => {
    return () => {
        return csvListService.UpdateSkipDuplicateAddressCheckFlag(event, autGenerateId);
    }
}
export const fileUpload = (formdata) => {
    return () => {
        return csvListService.fileUpload(formdata);
    }
}
export const getIntegrationTemplateUrl = (downloadParams) => {
    return () => {
        return csvListService.getIntegrationTemplateUrlService(downloadParams);
    }
}

const getCsvColumnListSuccess = (response) => ({
    type: csvIntegrationConstant.GET_COLUMN_LIST_SUCCESS,
    payload: response,
});
const getCsvColumnListPeding = () => ({
    type: csvIntegrationConstant.GET_COLUMN_LIST_PENDING,
});
const getCsvColumnListFailed = () => ({
    type: csvIntegrationConstant.GET_COLUMN_LIST_FAILURE,
});

export const getCsvColumnList = (moduleId) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(getCsvColumnListPeding());
            return csvListService.getCsvColumnListService(moduleId).then(
                (result) => {
                    dispatch(getCsvColumnListSuccess(result.data.EntityList));
                    return resolve(result.EntityList);
                },
                (error) => {
                    dispatch(getCsvColumnListFailed())
                    return reject(new Error(error?.message || "Failed to fetch CSV column list"));
                }
            );
        });
    }
}

export const checkIntegrationName = (integrationName) => {
    return () => {
        return createintegrationService.checkDuplicateIntegration(integrationName);
    }
}
export const mappingListBackDetails = (data) => ({
    type: csvIntegrationConstant.MAPPING_LIST_BACK_DETAILS,
    payload: data,
});

export const resetCsvColumnList = () => ({
    type: csvIntegrationConstant.RESET_COLUMNS_MAPPING_LIST,
    payload: [],
});

export const getSampleTemplateByModuleId = (bulkUploadModuleId) => {
    return axios.post(`${apiUrl}/GetBulkUploadTemplateByModuleId?bulkUploadModuleId=${bulkUploadModuleId}`);
};

export const getReportTypes = () => {
    return (dispatch) => {
        csvListService.getCarrierReportType().then((result) => {
            dispatch({
                type: reportTpes.REPORT_TYPES_SUCCESS,
                payload: result.data.EntityList || []
            });
        }).catch((error) => {
            console.error("Error fetching Report Types List", error);
        });
    }
};

export const uploadCarrierReport = (data, reportTypeId) => {
    return axios.post(`${apiUrl}/api/CarrierReports/upload-report-csv?reportType=${reportTypeId}`, data);
};

export const processReviewCsv = (data) => {
    return axios.post(`${apiUrl}/api/CarrierReports/process-review-csv`, data);
};
